module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_bottom_black-212ee941585ee3a75fec2ffb73aa2b51.svg";